const YOUTUBE_ID_REGEXP = /(?:youtu\.be\/|youtube\.com\/(?:watch\?(?:.*&)?v=|(?:embed|v)\/))([^?&"'>]+)/

/** Video id from a youtu.be or youtube.com link */
export const getYoutubeId = (link: string): string | null => link.match(YOUTUBE_ID_REGEXP)?.[1] ?? null

export const getYoutubeEmbedUrl = (videoId: string | null) => (
  `https://www.youtube.com/embed/${videoId}?modestbranding=1&autohide=1&showinfo=0&disablekb=1&loop=1`
)

export const getYoutubePreviewUrl = (videoId: string | null) => (
  videoId ? `https://img.youtube.com/vi/${videoId}/0.jpg` : ''
)
